// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categoryForm_container__6kw6\\+ {
  width: 560px;
  min-height: 340px;
  padding: 30px 20px 20px 20px;
  display: flex;
  border-radius: 4px 4px 4px 4px;
  background: #FFF;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 10px; }
  .categoryForm_container__6kw6\\+ input {
    height: 40px;
    border-radius: 4px;
    padding: 4px 4px 4px 4px;
    border-width: 1px;
    border-color: #9e9e9e;
    width: 100%; }
  .categoryForm_container__6kw6\\+ select {
    height: 40px;
    border-radius: 4px;
    padding: 4px 4px 4px 4px;
    border-width: 1px;
    border-color: #9e9e9e;
    width: 100%; }
  .categoryForm_container__6kw6\\+ textarea {
    border-radius: 4px;
    padding: 4px 4px 4px 4px;
    border-width: 1px;
    border-color: #9e9e9e;
    width: 100%;
    resize: none; }

.categoryForm_textarea__e2PeH {
  height: 200px;
  border-radius: 4px;
  padding: 4px 4px 4px 4px;
  border-width: 1px;
  border-color: #9e9e9e;
  width: 100%; }

.categoryForm_title__csfQi {
  font-weight: 600;
  font-size: 24px;
  line-height: 150%; }

.categoryForm_plainText__gaBLU {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px; }

.categoryForm_formContainer__baQ9a {
  display: flex;
  flex-direction: column;
  row-gap: 10px; }

.categoryForm_buttonsContainer__JGd30 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 10px; }

.categoryForm_formDataContainer__lTU8- {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between; }
  .categoryForm_formDataContainer__lTU8- input {
    width: 40%;
    height: 32px; }

.categoryForm_uploadButton__HoZgp {
  cursor: pointer;
  margin-top: -10px;
  height: 32px;
  width: 214px;
  background-color: #fe6100;
  color: white;
  border-radius: 4px;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/categoryForm/categoryForm.module.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/common.scss"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa,EAAA;EATf;IAWI,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,qBAAoC;IACpC,WAAW,EAAA;EAhBf;IAmBM,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,qBAAoC;IACpC,WAAW,EAAA;EAxBjB;IA2BI,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,qBAAoC;IACpC,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAoC;EACpC,WAAW,EAAA;;AAGb;ECzCE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AD2CnB;ECfE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;ADiBnB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;EAJhC;IAMI,UAAU;IACV,YAAY,EAAA;;AAIhB;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,yBAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EEtFb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EFsFvB,kBAAkB,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.container {\n  width: 560px;\n  min-height: 340px;\n  padding: 30px 20px 20px 20px;\n  display: flex;\n  border-radius: 4px 4px 4px 4px;\n  background: #FFF;\n  flex-direction: column;\n  justify-content: space-between;\n  row-gap: 10px;\n  input {\n    height: 40px;\n    border-radius: 4px;\n    padding: 4px 4px 4px 4px;\n    border-width: 1px;\n    border-color: rgba(158, 158, 158, 1);\n    width: 100%;\n  }\n  select {\n      height: 40px;\n      border-radius: 4px;\n      padding: 4px 4px 4px 4px;\n      border-width: 1px;\n      border-color: rgba(158, 158, 158, 1);\n      width: 100%;\n  }\n  textarea {\n    border-radius: 4px;\n    padding: 4px 4px 4px 4px;\n    border-width: 1px;\n    border-color: rgba(158, 158, 158, 1);\n    width: 100%;\n    resize: none;\n  }\n}\n\n.textarea {\n  height: 200px;\n  border-radius: 4px;\n  padding: 4px 4px 4px 4px;\n  border-width: 1px;\n  border-color: rgba(158, 158, 158, 1);\n  width: 100%;\n}\n\n.title {\n  @include h2\n}\n\n.plainText {\n  @include body1;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n}\n\n.buttonsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  column-gap: 10px;\n}\n\n.formDataContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  input {\n    width: 40%;\n    height: 32px;\n  }\n}\n\n.uploadButton {\n  cursor: pointer;\n  margin-top: -10px;\n  height: 32px;\n  width: 214px;\n  background-color: rgba(254, 97, 0, 1);\n  color: white;\n  border-radius: 4px;\n  display: flex;\n  @include flexCenter;\n  align-self: center;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n","\n@mixin flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `categoryForm_container__6kw6+`,
	"textarea": `categoryForm_textarea__e2PeH`,
	"title": `categoryForm_title__csfQi`,
	"plainText": `categoryForm_plainText__gaBLU`,
	"formContainer": `categoryForm_formContainer__baQ9a`,
	"buttonsContainer": `categoryForm_buttonsContainer__JGd30`,
	"formDataContainer": `categoryForm_formDataContainer__lTU8-`,
	"uploadButton": `categoryForm_uploadButton__HoZgp`
};
export default ___CSS_LOADER_EXPORT___;
